// extracted by mini-css-extract-plugin
export var location = "Location-module--location--RYt2Y";
export var icon = "Location-module--icon--2fRq9";
export var animateIn = "Location-module--animateIn--J78br";
export var locationIcon = "Location-module--locationIcon--nbnO9";
export var carretIcon = "Location-module--carretIcon--1bENq";
export var text = "Location-module--text--1pASE";